import { email, minLength8, number, required } from "utils/validate.util";
import InputRedux from "components/molecules/InputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields/index";
import CheckboxRedux from "components/molecules/CheckboxRedux";

export { default } from "./UpdateOrderForm";

export const fields: ReduxFormField[] = [
  {
    name: "status",
    label: "Status",
    component: CheckboxRedux,
    cellProps: { lg: 12 },
  },
  {
    name: "userName",
    label: "Username",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 6 },
  },
  {
    name: "phone",
    label: "Phone",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 6 },
    InputProps: { type: "number" },
  },
  {
    name: "email",
    label: "Email",
    validate: [required, email],
    component: InputRedux,
    cellProps: { lg: 6 },
    InputProps: { type: "email" },
  },
  {
    name: "password",
    label: "Password",
    validate: [required, minLength8],
    component: InputRedux,
    cellProps: { lg: 6 },
    InputProps: { showIcon: true, type: "password" },
  },
];
